import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { isPdfRenderedExtension } from "@air/utils-clips";
import React, { memo, useCallback, useMemo, useState } from "react";
import { EditableClipSharePrivateLink } from "~/components/SharePrivateClipModal/EditableClipSharePrivateLink";
import { useUpdateShareClipLink } from "~/components/SharePrivateClipModal/hooks/useUpdateShareClipLink";
import { SharePrivateClipPDFPage } from "~/components/SharePrivateClipModal/SharePrivateClipPDFPage";
import { EnableSharedLinkToggle } from "~/components/SharePrivateContentModal/EnableSharedLinkToggle";
import { EnableShareLinkDownloadToggle } from "~/components/SharePrivateContentModal/EnableShareLinkDownloadToggle";
import { SharePrivateContentExpirationDateDisplay } from "~/components/SharePrivateContentModal/SharePrivateContentExpirationDateDisplay";
export const SharePrivateClipLinkInfo = /*#__PURE__*/ memo((param)=>{
    let { shortIdInfo, clip, trackLocation, goToSettings, boardContext } = param;
    const [selectedPage, setSelectedPage] = useState(undefined);
    const { onShortUrlUpdate, isLoading } = useUpdateShareClipLink({
        clipId: clip.id,
        shortIdInfo
    });
    const onToggleEnableLink = useCallback((enabled)=>onShortUrlUpdate({
            disabled: !enabled
        }), [
        onShortUrlUpdate
    ]);
    const onDownloadToggle = useCallback((enabled)=>onShortUrlUpdate({
            permissions: {
                asset: {
                    canViewOriginal: enabled
                }
            }
        }), [
        onShortUrlUpdate
    ]);
    const urlSearchParams = useMemo(()=>{
        if (!selectedPage) return undefined;
        const searchParams = new URLSearchParams();
        searchParams.set("page", selectedPage.toString());
        return searchParams;
    }, [
        selectedPage
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col gap-3",
        children: [
            /*#__PURE__*/ _jsx(EnableSharedLinkToggle, {
                enabled: !shortIdInfo.disabled,
                isLoading: isLoading,
                onToggle: onToggleEnableLink
            }),
            !shortIdInfo.disabled && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(EnableShareLinkDownloadToggle, {
                        enabled: shortIdInfo.permissions.asset.canViewOriginal,
                        isLoading: isLoading,
                        onToggle: onDownloadToggle,
                        infoText: "This asset or version can be downloaded or saved to other Air workspaces"
                    }),
                    /*#__PURE__*/ _jsx(EditableClipSharePrivateLink, {
                        boardContext: boardContext,
                        clip: clip,
                        trackLocation: trackLocation,
                        shortIdInfo: shortIdInfo,
                        searchParams: urlSearchParams
                    }),
                    !!shortIdInfo.expirationDate && /*#__PURE__*/ _jsx(SharePrivateContentExpirationDateDisplay, {
                        expirationDate: shortIdInfo.expirationDate,
                        goToAdvancedSettings: goToSettings
                    }),
                    isPdfRenderedExtension(clip.ext) && /*#__PURE__*/ _jsx(SharePrivateClipPDFPage, {
                        onSelectPage: setSelectedPage
                    })
                ]
            })
        ]
    });
});
SharePrivateClipLinkInfo.displayName = "SharePrivateClipLinkInfo";
